import React, { useRef } from 'react';
import RagnaDataTable from '../ReactComponents/RagnaDataTable.jsx';
import axios from 'axios';
import { ajax_api, getAccess } from '../../Globals.jsx';
import { useOutlet, Outlet, useOutletContext } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const Sessions = props => {
    //datatable options
    const [refreshTable] = useOutletContext();
    const table_columns = [
        { display: "Name", col: "Name" }
    ];
    const search_columns = [
        { display: "Name", col: "Name" }
    ];
    const outlet = useOutlet();
    const editInput = useRef(null);

    return <>

        <Helmet>
            <title>LTS | Manage Sessions</title>
        </Helmet>
        {
            outlet != null ? <Outlet /> :
                <RagnaDataTable
                    refreshTable={refreshTable}
                    title="SP Sessions"
                    columns={table_columns}
                    s_columns={search_columns}
                    defaultOrder={false}
                    maxPagination={8}
                    generalSearch={true}
                    defaultOrderCol="ID"
                    url={ajax_api + "item-props/get-sessions"}
                    actions={[
                        {
                            hideIf: !getAccess("94"),
                            action: "modal", display: "Edit",
                            body: d => <>Name: <input ref={editInput} className="form-control" defaultValue={d.Name} key={d.Id} /></>, title: "Edit Data",
                            footer: (d, mOpen, refresh) => <button className="ro-button" onClick={_ => {
                                var form_data = new FormData();
                                form_data.append("Name", editInput.current.value);
                                form_data.append("Id", d.Id);

                                axios.post(`${ajax_api}item-props/sessions/edit`, form_data, {withCredentials: true}).then(_ => {
                                    mOpen(false);
                                    refresh();
                                }).catch(e => alert(e))
                            }}>
                                <span>Save</span>
                            </button>
                        },
                        {
                            hideIf: !getAccess("95"),
                            action: "url_confirm", display: "Delete",
                            content: d => `${ajax_api}item-props/sessions/delete/${d.Id}`,
                            body: d => `Are you sure you want to delete Session named "${d.Name}" ?`, title: "Delete Data"
                        },
                        //{
                        //    action: "modal", display: "Cust",
                        //    content: d => { return { title: "title modal", body: "full name: " + d.full_name, footer: <span>footer</span> } }
                        //},
                    ]}
                />
        }
    </>
}

export default Sessions;